var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-page-search"},[_c('Textbox',{attrs:{"placeholder":"Search for a product","type":"search"},on:{"search":_vm.handleSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }